var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 11.1453C21 13.9865 19.8938 16.7114 17.9246 18.7204C15.9555 20.7295 13.2848 21.8581 10.5 21.8581C7.71523 21.8581 5.04451 20.7295 3.07538 18.7204C1.10625 16.7114 0 13.9865 0 11.1453C0 8.30406 1.10625 5.5792 3.07538 3.57015C5.04451 1.56111 7.71523 0.432434 10.5 0.432434C13.2848 0.432434 15.9555 1.56111 17.9246 3.57015C19.8938 5.5792 21 8.30406 21 11.1453ZM10.5 5.1193C10.5 4.94173 10.4309 4.77142 10.3078 4.64586C10.1847 4.52029 10.0178 4.44975 9.84375 4.44975C9.6697 4.44975 9.50278 4.52029 9.37971 4.64586C9.25664 4.77142 9.1875 4.94173 9.1875 5.1193V12.4844C9.18754 12.6024 9.21815 12.7183 9.27623 12.8204C9.33432 12.9224 9.41781 13.007 9.51825 13.0656L14.112 15.7438C14.2628 15.8269 14.4394 15.8466 14.6042 15.7986C14.7689 15.7506 14.9088 15.6387 14.9938 15.4869C15.0788 15.3351 15.1023 15.1554 15.0591 14.9862C15.016 14.817 14.9097 14.6717 14.763 14.5814L10.5 12.096V5.1193Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21.4257,
    fill: "white",
    transform: "translate(0 0.432434)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.cc1952e6ba15ebeb21bb283b5bc3124e.svg";
export { ForwardRef as ReactComponent };